type ItemWithSequence = {
  sequence_number?: number | string;
  [key: string]: any;
};

export function sortBySequenceNumber<T extends ItemWithSequence>(
  items: T[]
): T[] {
  if (!items || !Array.isArray(items)) {
    return items || [];
  }

  const sortedItems = [...items].sort((a, b) => {
    const seqA = a.sequence_number;
    const seqB = b.sequence_number;

    const numA = typeof seqA === 'string' ? parseInt(seqA, 10) : seqA;
    const numB = typeof seqB === 'string' ? parseInt(seqB, 10) : seqB;

    const isValidA = typeof numA === 'number' && !isNaN(numA);
    const isValidB = typeof numB === 'number' && !isNaN(numB);

    if (!isValidA && !isValidB) {
      return Math.random() - 0.5;
    }

    if (!isValidA) return 1;
    if (!isValidB) return -1;

    if (numA === numB) {
      return Math.random() - 0.5;
    }

    return numA - numB;
  });

  return sortedItems;
}
